import { useId } from "react";
/** Exploratory cockpit identity; the public/approved brand assets remain intact. */
export function PulseBoardMark() {
  const id = useId();
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      className="pb-premium-mark"
    >
      <defs>
        <linearGradient
          id={`${id}-face`}
          x1="8"
          y1="3"
          x2="57"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ade5d8" />
          <stop offset=".38" stopColor="#458f88" />
          <stop offset="1" stopColor="#123e3d" />
        </linearGradient>
        <linearGradient
          id={`${id}-edge`}
          x1="15"
          y1="6"
          x2="48"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#e3fff4" />
          <stop offset="1" stopColor="#6ba9a1" />
        </linearGradient>
      </defs>
      <rect x="4" y="6" width="56" height="56" rx="18" fill="#082b2d" />
      <rect
        x="4"
        y="2"
        width="56"
        height="56"
        rx="18"
        fill={`url(#${id}-face)`}
        stroke={`url(#${id}-edge)`}
      />
      <path
        d="M23 43V17H35C42 17 45 21 45 27S41 36 35 36H29"
        stroke="#f4fff8"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 35H21L25 29L30 42L35 33H51"
        stroke="#c2dfc1"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="49" cy="14" r="3" fill="#e4c993" />
    </svg>
  );
}
